export default class PhoneService {
    static formatUnknownCountry(phoneNumber) {
        if (phoneNumber.length === 10 && phoneNumber.startsWith('06')) {
            return phoneNumber.replace(/^06+/, '00316');
        }

        if (phoneNumber.length === 9 && phoneNumber.startsWith('6')) {
            return '0031' + phoneNumber;
        }

        return phoneNumber;
    }
}